// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-space {
  font-size: 2.5em;
  opacity: 0.8;
}

.module-title {
  font-weight: 600;
}

.spaced {
  margin-left: 15px;
}

ion-item ion-avatar {
  width: 48px;
  height: 48px;
  display: flex;
  margin: auto 0;
}
ion-item ion-avatar ion-icon {
  width: 28px;
  height: 28px;
  margin: auto;
}
ion-item ion-label h2 {
  font-family: var(--font);
  font-weight: 600;
}
ion-item ion-label p {
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}

ion-item:last-child {
  --border-color: none;
  --border-size: 0;
  --border-style: none;
  border-bottom: none;
}

.interactiveImg {
  width: 98%;
  height: 225px;
  margin: 1%;
}

.interactivityContainer {
  display: flex;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);
  flex-direction: column;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/interactivity/interactivity.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAII;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AADR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAAZ;AAIQ;EACI,wBAAA;EAA0B,gBAAA;AADtC;AAGQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAAZ;;AAIA;EACI,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AADJ;;AAIA;EAEI,UAAA;EACA,aAAA;EACA,UAAA;AAFJ;;AAMA;EACI,aAAA;EACA,0EAAA;EACA,sBAAA;EACA,mBAAA;AAHJ","sourcesContent":[".icon-space {\n    font-size: 2.5em;\n    opacity: 0.8;   \n}\n\n.module-title {\n    font-weight: 600;\n}\n\n.spaced {\n    margin-left: 15px;\n}\n\nion-item{\n    //margin-top: 10px;    \n    ion-avatar{\n        width: 48px;\n        height: 48px;\n        display: flex;\n        margin: auto 0;\n        ion-icon{\n            width: 28px;\n            height: 28px;\n            margin: auto;\n        }\n    }\n    ion-label{\n        h2{\n            font-family: var(--font); font-weight: 600;;\n        }\n        p{\n            font-family: var(--font); font-weight: 300;;\n            font-size: 12px;\n        }\n    }\n}\nion-item:last-child {\n    --border-color: none;\n    --border-size: 0;\n    --border-style: none;\n    border-bottom: none;\n}\n\n.interactiveImg{\n\n    width: 98%;\n    height: 225px;\n    margin: 1%;\n}\n\n\n.interactivityContainer{\n    display: flex;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);\n    flex-direction: column;\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
